import React from 'react';
import SectionNotFound from '../components/styled/section/SectionNotFound';
import { SettingConsumer } from '../contexts/settingContext';
import { CODE_PAGE_NOT_FOUND, PAGE_NOT_FOUND, PAGE_NOT_FOUND_EN } from '../utils/common/constant';

const PageNotFound = () => {
  return (
    <SettingConsumer>
      {
        ({ locale }) => (
          <SectionNotFound>
            <h2>{CODE_PAGE_NOT_FOUND}</h2>
            <p>{locale === 'id' ? PAGE_NOT_FOUND : PAGE_NOT_FOUND_EN}</p>
          </SectionNotFound>
        )
      }
    </SettingConsumer>
  );
};

export default PageNotFound;
